import { render, staticRenderFns } from "./gHead.vue?vue&type=template&id=446c73fb&scoped=true&"
import script from "./gHead.vue?vue&type=script&lang=js&"
export * from "./gHead.vue?vue&type=script&lang=js&"
import style0 from "./gHead.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./gHead.vue?vue&type=style&index=1&id=446c73fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446c73fb",
  null
  
)

export default component.exports